import React, { useState, useEffect, useRef } from 'react';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HashRouter } from "react-router-dom";
import { motion } from 'framer-motion'; // Import framer-motion
import CheckoutLayout from "./CheckoutLayout";
import PageAddress from './Checkoutpages/BlockAddress/PageAddress'; 
import PageShipping from './Checkoutpages/BlockShipping/PageShipping'; 
import PagePayment from './Checkoutpages/BlockPayment/PagePayment'; 
import PageReview from './Checkoutpages/BlockReview/PageReview'; 
import { ReduxCheckoutProvider } from '../../redux/checkoutredux/ReduxCheckoutContext.tsx';
import { setSelectedPaymentMollieInstance } from '../../redux/checkoutredux/actions/checkoutactions/checkoutActions'; 



import '../assets/Checkout.css';

function ModulNavigation({ store }) {
//  const [mollieInstance, setMollieInstance] = useState(null);
  const isMollieScriptLoaded = useRef(false);



  const initializeMollie = () => {
    if (window.Mollie) {
      console.log("MOLLIE SCRIPT START");
      if (!window.mollieInstance) {
        console.log("MOLLIE SCRIPT START 2");
       // const mollie = window.Mollie('pfl_3RkSN1zuPE', { locale: 'de_DE', testmode: true });
       const mollie = window.Mollie('pfl_HJvSU4zNy6', { locale: 'de_DE', testmode: true });
        window.mollieInstance = mollie;
       // setMollieInstance(mollie);
       
        store.dispatch(setSelectedPaymentMollieInstance(mollie));
        console.log("THE MOLLIE zero: ", mollie);
      } else {
       // setMollieInstance(window.mollieInstance);
       store.dispatch(setSelectedPaymentMollieInstance(window.mollieInstance));
        console.log("USING EXISTING MOLLIE: ", window.mollieInstance);
      }
    } else {
      console.log("NO MOLLIE INITIALISATION: ");
    }
  };


  const loadMollieScript = () => {
    window.addEventListener('load', () => {
      if (!isMollieScriptLoaded.current) {
        const wpFooter = document.getElementById('wp_footer');
        if (wpFooter) {
          const mollieScript = wpFooter.querySelector('#mollie-js');
          if (mollieScript) {
            console.log("MOLLIE SCRIPT FOUND");
            initializeMollie();
          } else {
            console.log("MOLLIE SCRIPT NOT FOUND IN wp_footer");
          }
        } else {
          console.log("wp_footer NOT FOUND");
        }
        isMollieScriptLoaded.current = true;
      }
    });
  };


  /*



  const loadMollieScript = () => {
    console.log("Multi load");
    if (!isMollieScriptLoaded.current) {
      console.log("Multi load inner");
      const script = document.createElement('script');
      script.src = 'https://js.mollie.com/v1/mollie.js';
      script.async = true;
      script.onload = () => {
        if (window.Mollie && !mollieInstance) {
          const mollie = window.Mollie('pfl_3RkSN1zuPE', { locale: 'de_DE', testmode: true });
          setMollieInstance(mollie);
          console.log("THE MOLLIE: ", mollie);
        } else {
          console.log("NO MOLLI INITIALISATION: ");
        }
      };
      document.body.appendChild(script);
      isMollieScriptLoaded.current = true;
    }
  };
  */

  useEffect(() => {
    loadMollieScript();
  }, []);


  return (
    <HashRouter>
      <ReduxCheckoutProvider store={store} > 
        <Routes>
          <Route path="" element={<CheckoutLayout />}>
            <Route index element={<PageWithFadeTransition element={<PageAddress />} />} />     
            <Route path="ips-shipping" element={<PageWithFadeTransition element={<PageShipping />} />} />
            <Route path="ips-payment" element={<PageWithFadeTransition element={<PagePayment/>} />} />
            <Route path="ips-orderreview" element={<PageWithFadeTransition element={<PageReview />} />} />
            <Route path="*" element={<PageWithFadeTransition element={<PageAddress />} />} />
          </Route>
        </Routes>
      </ReduxCheckoutProvider>
    </HashRouter>
  );
}

// Component to wrap the page components with fade transition
const PageWithFadeTransition = ({ element }) => {
  // Define the fade transition
  const fadeTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
  };

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={fadeTransition} // Use the fade transition
    >
      {element}
    </motion.div>
  );
};




export default ModulNavigation;